/* cf-inspection-mirror.js - Click Fencing, 2026-09-02
 *
 * Pete: "i just booked a site inspection on the website but it did not show up on the calander
 *        or anywhere it should in the crm i think?" then "it should also create a job?"
 *
 * =========================================================================================
 * WHY THE BOOKING VANISHED. /pages/book-a-site-inspection POSTs to the Cloudflare worker:
 *
 *     clickfencing-crm-api.ppfencing2.workers.dev/inspection-booking
 *
 * and that worker emails enquiries@ - which is why the booking EMAIL arrived and everything
 * looked fine from the outside. But the Supabase mirror in cf-plans.js only ever watched
 *
 *     ENQUIRY_RE = /clickfencing-crm-api[^/]*\/enquiry\b/i
 *
 * and "/inspection-booking" does not match "/enquiry". So nothing was mirrored: confirmed in
 * SQL, schedule_entries for the click business was 0, and no contact or quote from the
 * booking existed anywhere in the CRM. The lead lived only in an inbox.
 *
 * WHAT THIS FILE DOES. It watches BOTH ways a site inspection can be booked and sends each to
 * the click-inspection-intake edge function, which creates the contact and the JOB:
 *
 *   1. THE BOOKING PAGE - POST .../inspection-booking with
 *        { customer:{name,email,phone,address},
 *          booking:{preferredDay,preferredTime,fenceType,meters,gates,notes} }
 *      forwarded as-is.
 *
 *   2. FROM A QUOTE - the "Book a free site inspection" button on /pages/quote-review posts
 *      to .../enquiry, and cf-one-price.js attaches quote.inspectionBooking to that payload.
 *      cf-plans.js already mirrors /enquiry to click-quote-intake, which makes the contact and
 *      the quote - but never a job. That booking is picked up here too, so it lands on the
 *      calendar like any other, carrying its plan reference so the job links back to the
 *      exact fence the customer designed.
 *
 * SEPARATE FILE ON PURPOSE. cf-plans.js is ~34KB and owns every calculator plan reaching the
 * CRM. Re-uploading it whole to widen one regex risks the thing that already works, and this
 * is a different outcome anyway - a JOB, not a quote. Deleting this file restores the old
 * behaviour exactly.
 *
 * IT CAN ONLY EVER ADD. The original request is passed through untouched and its result
 * returned unchanged; the mirror is fire-and-forget and every entry point is wrapped, so a
 * failure here can never cost the booking the customer just made.
 */
(function () {
  'use strict';

  if (window.__cfInspectionMirror) return;
  window.__cfInspectionMirror = true;

  var INTAKE = 'https://mhzmtafzxeshqqtktbwh.supabase.co/functions/v1/click-inspection-intake';
  var BOOKING_RE = /clickfencing-crm-api[^/]*\/inspection-booking\b/i;
  var ENQUIRY_RE = /clickfencing-crm-api[^/]*\/enquiry\b/i;
  var LOG = '[cf-inspection-mirror]';

  var sent = {};

  function post(payload, tag) {
    try {
      /* One send per person + slot. A double-tapped Send, or a beacon firing alongside a
         fetch, must not book the same visit twice - the edge function is idempotent as well,
         but not making the call at all is cheaper than relying on it. */
      var c = payload.customer || {};
      var b = payload.booking || {};
      var stamp = [c.email || c.phone || '', b.preferredDay || '', b.preferredTime || ''].join('|');
      if (sent[stamp]) return;
      sent[stamp] = true;

      fetch(INTAKE, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        mode: 'cors'
      }).then(function (r) {
        try { console.log(LOG, tag, '->', r.status); } catch (e) {}
      })['catch'](function () {});
    } catch (e) {}
  }

  /* ---------------------------------------------------------------- 1. the booking page */

  function fromBookingPage(raw) {
    try {
      var b = typeof raw === 'string' ? JSON.parse(raw) : raw;
      if (!b || !b.customer) return;
      post({
        customer: b.customer,
        booking: b.booking || {},
        page: 'Click Fencing site inspection booking'
      }, 'booking page');
    } catch (e) {}
  }

  /* ---------------------------------------------------------------- 2. from a quote */

  /* cf-one-price.js writes quote.inspectionBooking only when the customer actually chose to
     book a visit, so its presence IS the signal - an ordinary enquiry has no such field and
     is left entirely alone here. */
  function fromQuoteEnquiry(raw) {
    try {
      var b = typeof raw === 'string' ? JSON.parse(raw) : raw;
      var q = b && b.quote;
      var ib = q && q.inspectionBooking;
      if (!b || !b.customer || !ib) return;

      var cust = b.customer || {};
      post({
        customer: {
          name: cust.name || '',
          email: cust.email || '',
          phone: cust.phone || '',
          address: [cust.address, cust.suburb, cust.postcode].filter(Boolean).join(', ')
        },
        booking: {
          preferredDay: ib.preferredDay || q.deliveryDate || '',
          preferredTime: ib.preferredTime || '',
          fenceType: q.calcType || '',
          meters: '',
          gates: '',
          notes: (ib.bookingType || 'Site inspection') +
                 (ib.estimatedSupplyAndInstall ? ' - quoted ' + ib.estimatedSupplyAndInstall : '')
        },
        planRef: ib.planRef || b.quoteReference || q.planRef || '',
        page: 'Click Fencing quote review - site inspection'
      }, 'quote review');
    } catch (e) {}
  }

  /* ---------------------------------------------------------------- the taps */

  function bodyToText(body, cb) {
    try {
      if (!body) return cb(null);
      if (typeof body === 'string') return cb(body);
      if (typeof Blob !== 'undefined' && body instanceof Blob) {
        if (body.text) { body.text().then(cb)['catch'](function () { cb(null); }); return; }
        return cb(null);
      }
      if (typeof body === 'object') return cb(JSON.stringify(body));
      cb(null);
    } catch (e) { cb(null); }
  }

  function look(url, body) {
    try {
      if (BOOKING_RE.test(url)) bodyToText(body, function (t) { if (t) fromBookingPage(t); });
      else if (ENQUIRY_RE.test(url)) bodyToText(body, function (t) { if (t) fromQuoteEnquiry(t); });
    } catch (e) {}
  }

  try {
    var origFetch = window.fetch;
    if (typeof origFetch === 'function') {
      window.fetch = function (input, init) {
        try {
          var url = typeof input === 'string' ? input : (input && input.url) || '';
          if (init && init.body) look(String(url), init.body);
        } catch (e) {}
        return origFetch.apply(this, arguments);
      };
    }
  } catch (e) {}

  try {
    if (navigator.sendBeacon) {
      var origBeacon = navigator.sendBeacon.bind(navigator);
      navigator.sendBeacon = function (url, data) {
        try { look(String(url), data); } catch (e) {}
        return origBeacon(url, data);
      };
    }
  } catch (e) {}

  try { console.log(LOG, 'installed'); } catch (e) {}
})();
